import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { appliedFilterTemplateSelector } from "./appliedFilterTemplateSelector";

export const appliedFilterTemplateNameSelector = createDraftSafeSelector(
  [appliedFilterTemplateSelector],
  (appliedFilterTemplate) => {
    return appliedFilterTemplate?.name;
  },
);
